import React, { Fragment } from 'react'
import { injectStripe, CardNumberElement, CardCVCElement, CardExpiryElement, PostalCodeElement } from 'react-stripe-elements'
import Currency from 'components/UI/Currency'
import Button from 'components/UI/Button/Button'
import Icon from 'components/UI/Icon/Icon'
import Formsy from 'formsy-react'

import {
  ButtonsContainer,
  CardDetails,
  Heading,
  Title,
  MessageText,
  Price,
  PriceStrikethrough,
  DiscountMessage,
  Coupon,
  StyledFormInput,
  Message,
  StyledLabel,
  CardDetailsRow,
  CardDetailsNumber,
  ExpiryDate,
  SecurityCode,
  PostalCode,
  FormContainer
} from './CheckoutForm.styles'
import PropTypes from 'prop-types'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import Loader from 'components/UI/Loader/Loader'
class CheckoutForm extends React.Component {
  static propTypes = {
    plan: PropTypes.shape({
      id: PropTypes.string,
      nickname: PropTypes.string,
      amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      currency: PropTypes.string
    }).isRequired,
    onCancel: PropTypes.func,
    subscription: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.state = {
      message: null,
      loading: false,
      error: false,
      success: false,
      couponCode: null,
      couponDiscount: null,
      errorMessage: undefined
    }
  }

  onSuccess () {
    this.props.onSuccess()
    this.setState({
      success: true,
      error: false,
      loading: false,
      errorMessage: undefined
    })
  }

  onRetry () {
    this.setState({
      success: false,
      error: false,
      loading: false,
      errorMessage: undefined
    })
  }

  onSubmit () {
    this.setState({
      success: false,
      error: false,
      loading: true,
      errorMessage: undefined
    })
  }

  onError (e) {
    this.setState({
      success: false,
      error: true,
      loading: false,
      errorMessage: e.code && e.type ? e.message : undefined
    })
  }

  renderErrorMessage () {
    return <Message>
      <MessageText>{ this.state.errorMessage || 'An error occurred!' }</MessageText>
      <Button bgColor='red' color='white' width='calc(50% - 10px)' onClick={this.props.onCancel}>Cancel</Button>
      <Button color='white' width='calc(50% - 10px)' onClick={this.onRetry.bind(this)}>Retry</Button>
    </Message>
  }

  renderSuccessMessage () {
    return <Message>
      <MessageText>Thank you for subscribing!</MessageText>
      <Button bgColor='red' color='white' size='regular' onClick={() => { window.location = '/edu/dashboard/classroom' }}>Go back</Button>
    </Message>
  }

  renderLoadingMessage () {
    return <Loader bgColor='rgba(0,0,0,0)' itemColor={colors.pink} itemSize='60' />
  }

  renderForm () {
    return (
      <FormContainer>
        { this.props.parent &&
          <Formsy onValidSubmit={async () => {
            const couponDiscount = await this.props.getDiscount(this.state.couponCode)
            if (couponDiscount) this.setState({ couponDiscount })
          }}>
            <Coupon>
              <StyledFormInput
                value={this.state.couponCode}
                onChange={(e) => this.setState({ couponCode: e.target.value })}
                name='coupon'
                validations='isExisty'
                placeholder='Coupon'
                width='250px'
              />
              <Button
                element='button'
                bgColor={this.state.couponDiscount ? colors.success : undefined}
                color='white'
              >
                {this.state.couponDiscount ? 'Applied' : 'Apply'}
              </Button>
            </Coupon>
          </Formsy>
        }
        <CardDetails>
          <CardDetailsRow>
            <StyledLabel>
            Card number
              <CardDetailsNumber><CardNumberElement style={{ base: { fontSize: '18px' } }} /></CardDetailsNumber>
            </StyledLabel>
            <StyledLabel>
            Expiration
              <ExpiryDate><CardExpiryElement style={{ base: { fontSize: '18px' } }} /></ExpiryDate>
            </StyledLabel>
          </CardDetailsRow>
          <CardDetailsRow>

            <StyledLabel>
            Security Code
              <SecurityCode><CardCVCElement style={{ base: { fontSize: '18px' } }} /></SecurityCode>
            </StyledLabel>
            { /* <StyledLabel>
            Post code
            <PostalCode><PostalCodeElement style={{base: {fontSize: '18px'}}} /></PostalCode>
          </StyledLabel> */ }
          </CardDetailsRow>

        </CardDetails>
        <ButtonsContainer>
          <Button
            onClick={this.handleCheckoutFormSubmit.bind(this)}
            color='white'
            bgColor={colors.success}
          >
            Confirm
          </Button>
          <Button
            onClick={this.props.onCancel}
            color='white'
            bgColor='red'
          >
            Cancel
          </Button>
        </ButtonsContainer>
      </FormContainer>
    )
  }

  handleCheckoutFormSubmit (e) {
    const coupon = this.state.couponCode ? this.state.couponCode : undefined

    this.onSubmit()
    if (this.props.stripe) {
      this.props.stripe.createToken().then(payload => {
        if (payload.error) {
          return this.onError(payload.error)
        }
        this.props
          .handleStripeToken(this.props.plan, payload.token, coupon)
          .then(response => {
            this.onSuccess()
          })
          .catch(e => {
            this.onError(e)
          })
      })
    } else {
      // this.props.handleError()
      console.log('Stripe is not defined.')
    }
  }

  renderPlanAmount () {
    const discountPercentage = this.props.subscription && this.props.subscription.discountPercentage || 0
    const couponDiscount = this.state.couponDiscount || 0

    if (discountPercentage || couponDiscount) {
      return (
        <Fragment>
          <PriceStrikethrough>
            <Currency amount={this.props.plan.amount / 100} currency={this.props.plan.currency} />
          </PriceStrikethrough>
          <Price>
            <Currency amount={(this.props.plan.amount - (this.props.plan.amount * ((discountPercentage + couponDiscount) / 100))) / 100} currency={this.props.plan.currency} />
          </Price>
          <DiscountMessage>Your discount has been applied!</DiscountMessage>
        </Fragment>
      )
    } else return <Price><Currency amount={this.props.plan.amount / 100} currency={this.props.plan.currency} /></Price>
  }

  render () {
    const { product, plan } = this.props
    return (
      <div>
        <Heading>
          <Title>
              One {product.name} Paid{' '}
            {plan.interval === 'year' ? 'yearly' : 'monthly'}
          </Title>
          {this.renderPlanAmount()}
        </Heading>
        {this.state.loading ? this.renderLoadingMessage() : null}
        {this.state.error ? this.renderErrorMessage() : null}
        {this.state.success ? this.renderSuccessMessage() : null}
        {!this.state.success && !this.state.error
          ? this.renderForm()
          : null}
      </div>
    )
  }
}

export default injectStripe(CheckoutForm)
